module.exports = __webpack_public_path__ + "f44f1cb9ff63952f390525b9994062d7.MP3";